import invariant from 'tiny-invariant'
import type { ProductVariant } from 'typings/api'
import { FormValues } from '../ProductDetailPage'

type GenericObject = { [key: string]: unknown }
export const objectsEqual = (firstObject: GenericObject, secondObject: GenericObject) =>
  Object.keys(firstObject).length === Object.keys(secondObject).length &&
  Object.keys(firstObject).every((key) => firstObject[key] === secondObject[key])

export type TOptionFormat = { uid: string; value: string }
/**
 * Transforms the options object from
 * { side: 'right', size: 's' }
 * to
 * [{ uid: 'side', value: 'right' }, { uid: 'size', value: 's' }]
 */
export const transformFormValues = (values: FormValues): TOptionFormat[] =>
  Object.keys(values).map((key) => ({ uid: key, value: values[key] }))

type Arguments = { values: FormValues; items: ProductVariant[] }
/**
 * Matches a set of options to the correct item
 */
export const selectMatchingItem = ({ values, items }: Arguments): ProductVariant | null => {
  try {
    invariant(Object.keys(values).length, 'Not enough values supplied')
    invariant(items.length, 'Not enough items supplied')
    const transformedValues = transformFormValues(values)

    return items.find((item) => {
      const result = item.options.map((option) =>
        transformedValues.some((val) => objectsEqual(option, val)),
      )
      return !result.includes(false)
    })
  } catch (e) {
    console.error(e.message)
    return null
  }
}
